import React from 'react';
import { Snackbar } from '@mui/material';
import parse from 'html-react-parser';

import { useToastAlert } from 'hooks/useToastAlertHook';

import Alert from 'ui-component/alert/Alert';

const ToastAlert: React.FC = () => {
  const { openToast, handleClose, alertMessage, alertSeverity } = useToastAlert();

  return (
    <Snackbar open={openToast} autoHideDuration={6000} onClose={handleClose}>
      <Alert onClose={handleClose} severity={alertSeverity} sx={{ width: '100%' }}>
        {parse(alertMessage)}
      </Alert>
    </Snackbar>
  );
};

export default ToastAlert;
